import React, { useContext } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { SessionContext } from '../../contexts/SessionProvider'
import SiteService from '../../services/SiteService'
import Enumeration from '../../enumeration'

/**
 * Resolve the landing page a user is allowed to see, used when they try to
 * reach a route their group is not permitted to access. We bounce them to
 * their own dashboard rather than rendering the protected view.
 */
const resolveGroupHomeRoute = (loginSession) =>
{
	if (SiteService.isInGroup(loginSession, Enumeration.UserGroups.Administrators))
	{
		return '/secure/business-dashboard'
	}
	if (SiteService.isInGroup(loginSession, Enumeration.UserGroups.Dealers))
	{
		return '/secure/dealer-dashboard'
	}
	return '/public/login'
}

/**
 * Layout-route guard. Place protected routes as children of a
 * <Route element={ <RouteGuard allowedGroups={[...]} /> }> wrapper.
 *
 * - Unauthenticated users are redirected to the login page.
 * - Authenticated users who are not a member of one of the allowed groups are
 *   redirected to their own dashboard (prevents a dealer from reaching admin
 *   routes by typing the URL directly, and vice-versa).
 * - Otherwise the nested route renders via <Outlet />.
 */
const RouteGuard = ({ allowedGroups }) =>
{
	const sessionContext = useContext(SessionContext)
	const loginSession = sessionContext.loginSession

	if (!loginSession || !loginSession.isAuthenticated)
	{
		return <Navigate to="/public/login" replace />
	}

	const groups = allowedGroups || []
	const isAllowed = groups.some(groupId => SiteService.isInGroup(loginSession, groupId))
	if (!isAllowed)
	{
		return <Navigate to={ resolveGroupHomeRoute(loginSession) } replace />
	}

	return <Outlet />
}

export default RouteGuard
